import {
  GpkPraktikKinerjaGradingStateEnum,
  GpkPerilakuKerjaGradingStateEnum,
} from 'types/kinerja-gpk'

import type { TObservationResultTypes } from 'types/kinerja-pelaksanaan'
import type { KinerjaStatusGpk } from 'types/kinerja-gpk'

export const GPK_PEGAWAI_TUGAS_POKOK = [
  'Terlaksananya identifikasi kebutuhan belajar dan perencanaan pembelajaran dalam mewujudkan layanan pembelajaran bagi murid penyandang disabilitas',
  'Terlaksananya pembelajaran dalam mewujudkan layanan pembelajaran bagi murid penyandang disabilitas',
  'Terlaksananya penilaian hasil pembelajaran dalam mewujudkan layanan pembelajaran bagi murid penyandang disabilitas',
  'Terlaksananya pembimbingan atau pendampingan guru lainnya dalam mewujudkan layanan pembelajaran bagi murid penyandang disabilitas',
]

export const GPK_PEGAWAI_PRAKTIK_KINERJA_ICONS: Record<string, string> = {
  'Asesmen Pendidikan Khusus': 'img-reflection-documents-magnifying-glass.png',
  'Program Pembelajaran Individual': 'img-document-skills-improvement.png',
  'Interaksi Inklusif': 'img-sharing-chat-emoji-characters.png',
  'Bimbingan Sosial Emosional': 'img-heart-empathic-give.png',
  'Pembelajaran Adaptif': 'img-community-character-emoji-interaction.png',
  'Program Kompensatorik': 'img-flow-process.png',
  'Umpan Balik Guru': 'img-chat-talk.png',
  'Presentasi Pelibatan': 'img-presentation-data-chart.png',
}

export const GPK_PEGAWAI_PERENCANAAAN_STATUS_LABELS: Record<
  KinerjaStatusGpk,
  string
> = {
  NOT_FOUND: 'Belum diajukan',
  DRAFT: 'Belum diajukan',
  WAITING_APPROVAL: 'Menunggu pemeriksaan',
  WAITING_APPROVAL_PPK:
    'Sudah diperiksa Tim Kinerja dan perlu disetujui Pejabat Penilai Kinerja',
  REVISION_TK: 'Revisi dari Tim Kinerja',
  REVISION_PPK: 'Revisi dari Pejabat Penilai Kinerja',
  APPROVED: 'Disetujui Pejabat Penilai Kinerja',
  READY: 'Siap untuk pelaksanaan',
}

export const GPK_PELAKSANAAN_GRADING_STATE_LABELS: Record<
  GpkPraktikKinerjaGradingStateEnum,
  string
> = {
  [GpkPraktikKinerjaGradingStateEnum.OBSERVASI]: 'Observasi',
  [GpkPraktikKinerjaGradingStateEnum.NILAI_TINDAK_LANJUT]:
    'Rencana Tindak Lanjut',
  [GpkPraktikKinerjaGradingStateEnum.NILAI_REFLEKSI_TINDAK_LANJUT]:
    'Refleksi dan Evaluasi Tindak Lanjut',
  [GpkPraktikKinerjaGradingStateEnum.SELESAI]: 'Sudah Selesai',
}

export const GPK_PERILAKU_KERJA_GRADING_STATE_LABELS: Record<
  GpkPerilakuKerjaGradingStateEnum,
  string
> = {
  [GpkPerilakuKerjaGradingStateEnum.BELUM_DINILAI]: 'Belum Selesai',
  [GpkPerilakuKerjaGradingStateEnum.SELESAI]: 'Sudah Selesai',
}

export const GPK_RATING_OBSERVASI_OPTIONS: Record<
  TObservationResultTypes,
  string
> = {
  NOT_STARTED: 'Belum Dilakukan',
  START_NOT_EFFECTIVE: 'Dilakukan Tapi Belum Efektif',
  START_EFFECTIVE: 'Dilakukan Dan Efektif',
}
